import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatAssistant from './components/ChatAssistant';
import Home from './pages/Home';
import Login from './pages/Login';
import Overview from './pages/Overview';
import DeviceDetail from './components/DeviceDetail';
import MQTTClient from './components/MQTTClient';
import ImageGallery from './components/ImageGallery';
import ScrollToTop from './components/ScrollToTop';
import BluetoothConnect from './components/BluetoothConnect';
import './index.css';

function App() {
  const [mqttMessage, setMqttMessage] = useState<string>('');
  const [connectionCount, setConnectionCount] = useState<number>(0);

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Navbar />
      <MQTTClient onMessage={setMqttMessage} onConnectionCountChange={setConnectionCount} />
      <Routes>
        <Route path="/" element={<Home connectionCount={connectionCount} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/overview" element={<Overview mqttMessage={mqttMessage} />} />
        <Route path="/device/:mac" element={<DeviceDetail mqttMessage={mqttMessage} />} />
        <Route path="/products" element={<div className="section"><div className="container"><ImageGallery /></div></div>} />
        <Route path="/ble" element={<div className="section"><div className="container"><BluetoothConnect /></div></div>} />

        {/* Add other routes as needed */}
      </Routes>
      <Footer />
      <ChatAssistant />
    </Router>
  );
}

export default App;
